import { useMutation } from '@tanstack/react-query';
import { CHAT_API } from 'utils/globalApiServices';
import { queryClient } from 'hocs/QueryWrapper';
import { AI_CHAT } from '../queries/queryKeys';

const mutationFn = async ({ conversationId, messageId, feedback, reason }) => {
  const url = `conversations/${conversationId}/messages/${messageId}/feedback`;
  const data = await CHAT_API.patch(url, {
    feedback,
    ...(reason && { feedback_reason: reason }),
  });
  return data?.data || {};
};

const useSendFeedbackResponseMutation = () => {
  return useMutation({
    mutationFn: mutationFn,
    onMutate: async (messageInfo) => {
      // Snapshot the previous value
      const previousMessages = queryClient.getQueryData([
        AI_CHAT.CONVERSATION,
        messageInfo.conversationId,
      ]);

      // Optimistically update to the new value
      queryClient.setQueryData([AI_CHAT.CONVERSATION, messageInfo.conversationId], (old) =>
        old.map((msg) =>
          msg.message_id === messageInfo.messageId
            ? { ...msg, feedback: messageInfo.feedback }
            : { ...msg }
        )
      );

      // Return a context object with the snapshotted value
      return { previousMessages };
    },
    onSuccess: (response, variables) => {
      queryClient.invalidateQueries({
        queryKey: [AI_CHAT.CONVERSATION, variables.conversationId],
      });
    },
    onError: (err, updatedMessage, context) => {
      console.error('ERROR IN MUTATION', err);
      queryClient.setQueryData(
        [AI_CHAT.CONVERSATION, updatedMessage.conversationId],
        context.previousMessages
      );
    },
  });
};

export default useSendFeedbackResponseMutation;
